var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.visible)?_c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"color":'#4cda64',"loader":'dots',"background-color":'#fff',"is-full-page":_vm.fullPage}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }